import { palette } from "../theme/tokens";
import { useColorMode } from "../theme/ThemeProvider";

export function BrandMark({ size = 28 }: { size?: number }) {
  const { mode } = useColorMode();
  const c = palette[mode];
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden>
        <rect x="2" y="2" width="28" height="28" rx="8" fill={c.brand} />
        <path
          d="M9 11.5l7 5.5 7-5.5M9 11.5v9.5h14V11.5"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span style={{ fontWeight: 600, fontSize: 18, letterSpacing: -0.2 }}>Priomail</span>
    </span>
  );
}
